import { render } from "./Anesthesiology.vue?vue&type=template&id=02bd0923&scoped=true"
import script from "./Anesthesiology.vue?vue&type=script&lang=ts"
export * from "./Anesthesiology.vue?vue&type=script&lang=ts"

import "./Anesthesiology.vue?vue&type=style&index=0&id=02bd0923&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-02bd0923"

export default script